import { render, staticRenderFns } from "./gelirKaydi.vue?vue&type=template&id=b806cc52&scoped=true&"
import script from "./gelirKaydi.vue?vue&type=script&lang=js&"
export * from "./gelirKaydi.vue?vue&type=script&lang=js&"
import style0 from "./gelirKaydi.vue?vue&type=style&index=0&id=b806cc52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b806cc52",
  null
  
)

export default component.exports